import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listSubmitterMasters } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  ListSubmitterMastersRequestSchema,
  type ListSubmitterMastersResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 一覧の「発電」バッジ (spec AC-WFW-001) の突合に使う計画提出者マスタ一覧。
 * 失敗しても一覧画面全体を error boundary へ落とさず、呼び出し元で発電バッジと
 * フィルタ候補の欠落を表示する。
 * design `cases.html` の `_licenseBadgeOf` は引けないコードにバッジを付けない)。
 */
export function useListSubmitterMastersForBadge(): UseQueryResult<
  ListSubmitterMastersResponse,
  ConnectError
> {
  return useQuery(
    listSubmitterMasters,
    create(ListSubmitterMastersRequestSchema, {}),
    { throwOnError: false },
  )
}
